

import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import Btn from "../shared/button/Btn";
import { approveRegisterDraft } from "../../features/admin3/admin3Slice";
import SmallSpinner from "../shared/spinners/SmallSpinner";
import { useState } from "react";
import { deleteSavedEArsivCustomer, setSelectRegisteredUserEArsiv } from "../../features/e-Arsiv/eArsivSlice";
import { MdOutlineMoreHoriz } from "react-icons/md";

const Container = styled.div`
  width: 100%;
  margin-block: 5px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  .container {
    width: 100%;
    cursor: pointer;
    .content {
      width: 100% !important;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      color: ${({ theme }) => theme.mainTextColor} !important;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr 1fr;
        gap: 15px;
        text-align: center;
        background-color: transparent;
        height: 40px;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          display: flex;
          align-items: center;
          justify-content: center;
          
          span {
            font-size: 20px;
          }

          .btn-wrapper{
            display: flex;
            gap: 10px;
          }
          
        }
      }
    }
  }

  .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
        top: 25px;
      }
      .detail{
        position: absolute;
        top: 20px;
        right: 30px;
        background-color: var(--color-light);
        padding: 10px;
        border-radius: 10px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: ${({ theme }) => theme.mainTextColor};
        display: flex;
        flex-direction: column;
        gap: 10px;
        background-color: white;
      }
`;

const KayitliMusterilerContainer = ({ data}) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  const [isMoreActive, setIsMoreActive] = useState(null)

  const toggleMore = (item) => {
    if (isMoreActive === item) {
      setIsMoreActive(null);
    } else {
      setIsMoreActive(item);
    }
  };

  return (
    <Container onClick={()=>toggleMore(null)} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">
                {data?.name  || "-"} {" "} {data?.surname}
            </div>
            <div className="col">
                {data?.title || "-"}
            </div>
            <div className="col">
                {data?.vknTcKn  || "-"}
            </div>
            <div className="col">
                {data?.taxOffice  || "-"}
            </div>
           
            <div onClick={(e)=> {toggleMore(data); e.stopPropagation(e) }} className="more"><MdOutlineMoreHoriz/></div>
            {isMoreActive && 
                <div onClick={() => dispatch(setSelectRegisteredUserEArsiv(data))} className="detail">
                    <div onClick={() => dispatch(deleteSavedEArsivCustomer({id:data?.id}))} className="option">Sil</div>
                </div> 
            }
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KayitliMusterilerContainer;
